<template>
  <div class='h100vh-100'>
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <e-item prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("System.export")' :click="exportData"></e-item>
          <e-item prefixIcon='icon hero-icon hero-icon-details' :tooltipText='$t("System.detailLog")' :click="detailLog"></e-item>
        </e-items>
      </ejs-toolbar>
      <div class="h-inputBox">
        <input class="e-input" :placeholder='$t("System.taskId")' @keyup.enter="queryPage" v-model="keyString" />
        <div class="h-barSpace20"></div>
        <div class="h-barLit">{{$t('System.searchC')}}</div>
        <ejs-dropdownlist class="e-input" ref="list" :dataSource="items" :index="0" @change="queryPage"></ejs-dropdownlist>
        <div class="h-barSpace20"></div>
        <div class="h-barLit">{{$t('System.timeRange')}}</div>
        <ejs-daterangepicker class="e-input" ref="datePicker" :placeholder="$t('ej2Components.daterangepicker.placeholder')" :format="dateFormat" :locale="locale" :separator="separate" @change="queryPage" :allowEdit="false"></ejs-daterangepicker>
      </div>
    </div>
    <div class="h100-40 h-scroll">
      <ejs-treegrid ref="grid" height='calc(100vh - 280px)' childMapping="children" :treeColumnIndex="0" :enableCollapseAll="true">
        <e-columns>
          <e-column field="sysTaskName" :headerText='$t("System.taskName")' width="120" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="taskIdString" :headerText='$t("System.taskId")' width="150" textAlign="Center"></e-column>
          <e-column field="sysTaskLogLever" :headerText='$t("System.level")' width="130" textAlign="Center"></e-column>
          <e-column field="logTimeString" :headerText='$t("System.runTime")' width="120" textAlign="Center"></e-column>
          <e-column field="sysTaskCurrResult" :headerText='$t("System.result")' width="170" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-treegrid>
      <ejs-pager ref="pager" :currentPage='page.pageNo' :pageSize="page.pageSize" :pageCount="page.pageCount" @click="getMissionLogs"></ejs-pager>
      <CustomDialog ref='detail' :element='detailDialog.element' :styles='detailDialog.styles'>
        <template v-slot:dialog-content>
          <div v-html='detailData'></div>
        </template>
      </CustomDialog>
    </div>
  </div>
</template>

<script>
import CustomDialog from "../common/CustomDialog";
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "MissionLogs",
  data() {
    return {
      locale: localStorage.getItem('locale'),
      items: [
        { text: `${this.$t('System.result')}`, value: "" },
        { text: `${this.$t('System.reSuccess')}`, value: `${this.$t('System.reSuccess')}` },
        { text: `${this.$t('System.reFault')}`, value: `${this.$t('System.reFault')}` }
      ],
      page: {
        pageNo: 1,
        pageSize: 16,
        totalCount: 0,
        pageCount: 10
      },
      keyString: "",
      sysOrCustom: 0,
      separate: "-",
      dateFormat: "yyyy-MM-dd",
      startTimeLong: "",
      endTimeLong: "",
      detailDialog: {
        styles: {
          width: '810px',
          height: '752px',
          model: true,
          visible: false
        },
        element: {
          refName: "detailLog",
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('System.confirm') }, isPrimary: true }
          ],
          title: this.$t('System.detailLog')
        }
      },
      detailData: ''
    };
  },
  methods: {
    queryPage(){
      this.$loading.showLoadding(`${this.$t('MML.loadingTip')}`);
      const url = "/lte/ems/sysmanager/log/getlogpage";
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        keyString: this.keyString,
        sysOrCustom: this.sysOrCustom,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      };
      const logresult = this.items[this.$refs.list.ej2Instances.index].value;
      if (logresult != "") {
        params.logresult = logresult;
      }
      if (this.$refs.datePicker.ej2Instances.startDate != null) {
        this.startTimeLong = this.$refs.datePicker.ej2Instances.startDate.getTime();
        this.endTimeLong = this.$refs.datePicker.ej2Instances.endDate.getTime()+24*60*60*1000-1;
        params.startTimeLong = this.startTimeLong;
        params.endTimeLong = this.endTimeLong;
      }
      this.sendUrl(url, params);
    },
    getMissionLogs() {
      this.$loading.showLoadding(`${this.$t('MML.loadingTip')}`);
      const url = "/lte/ems/sysmanager/log/getlogpage";
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        keyString: this.keyString,
        sysOrCustom: this.sysOrCustom,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      };
      const logresult = this.items[this.$refs.list.ej2Instances.index].value;
      if (logresult != "") {
        params.logresult = logresult;
      }
      if (this.$refs.datePicker.ej2Instances.startDate != null) {
        this.startTimeLong = this.$refs.datePicker.ej2Instances.startDate.getTime();
        this.endTimeLong = this.$refs.datePicker.ej2Instances.endDate.getTime()+24*60*60*1000-1;
        params.startTimeLong = this.startTimeLong;
        params.endTimeLong = this.endTimeLong;
      }
      this.sendUrl(url, params);
    },
    sendUrl(url, params){
      this.axios.post(url,  params ).then(response => {
        this.$loading.hideLoadding();
        const result = response.data.result;
        if (result == null || result == "") {
          this.$refs.grid.ej2Instances.dataSource = result;
          this.$refs.pager.ej2Instances.totalRecordsCount = response.data.totalCount;
          return null;
        }
        const parents = result.filter(item => item.parentId == null);
        const children = result.filter(item => item.parentId != null);
        const showRe = [];
        children.forEach(item => {
          showRe.push(item);
        });
        this.$refs.grid.ej2Instances.dataSource = showRe;
        this.$refs.pager.ej2Instances.totalRecordsCount = response.data.totalCount;
      });
    },
    exportData() {
      const url = "/lte/ems/sysmanager/log/exportLog";
      if (this.$refs.datePicker.ej2Instances.startDate == null) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectTimeRange')});
        return null;
      }
      this.startTimeLong = this.$refs.datePicker.ej2Instances.startDate.getTime();
      this.endTimeLong = this.$refs.datePicker.ej2Instances.endDate.getTime()+24*60*60*1000-1;
      let paramstring = "?keyString=";
      if (this.keyString != "") {
        paramstring += this.keyString;
      }
      paramstring += "&sysOrCustom=" + this.sysOrCustom;
      let logresult = this.items[this.$refs.list.ej2Instances.index].value;
      if (logresult != "") {
        paramstring += "&logresult=" + encodeURI(encodeURI(logresult));
      }
      paramstring +=
        "&startTimeLong=" +
        this.startTimeLong +
        "&endTimeLong=" +
        this.endTimeLong;
      // 保存下载导出表格
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url + paramstring;
      document.body.appendChild(link);
      link.click();
    },
    dialogHide() {
      this.$refs.detail.clear();
      this.$refs.detail.close();
    },
    setListStatus() {

    },
    detailLog(){
      const record = this.getRecord();
      if (record == null) {
        return null;
      }
      this.detailData = record[0].sysTaskLog;
      if (record[0].children != null){
        if (record[0].children.length == 0) {
        if (this.detailData == null) {
          this.detailData = record[0].sysTaskLog;
          }
        } else {
          this.detailData = record[0]['children'][0].sysTaskLog;
        }
      }
      this.$refs.detail.show();
    },
    getRecord() {
      const record = this.$refs.grid.ej2Instances.getSelectedRecords();
      if (record == null || record == "") {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.selectOneMessage')});
        return null;
      }
      return record;
    },
    init(sysCustom){
      this.keyString = "";
      this.sysOrCustom = sysCustom;
      this.getMissionLogs();
    }
  },
  components: {
    CustomDialog
  }
};
</script>
